import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-doors-windows',
  templateUrl: './icon-doors-windows.component.html',
  styleUrls: ['./icon-doors-windows.component.scss']
})
export class IconDoorsWindowsComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
